module.exports = __webpack_public_path__ + "43056b0ccd92b6fae82ec62fb52b6b79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-webfont.svg
// module id = 225
// module chunks = 0